const API_BASE = import.meta.env.VITE_API_BASE_URL as string;

export async function reportError(error: Error, context?: string): Promise<void> {
  try {
    await fetch(`${API_BASE}client-errors/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: error.message,
        stack: error.stack ?? "",
        url: window.location.href,
        context: context ?? "",
      }),
    });
  } catch {
    // Never throw from error reporting
  }
}
